import { useMutation, useQueryClient } from 'react-query';
import { deleteActivity } from 'v2/api';
import { infiniteActivityKeys } from './query-keys';

export function useDeleteActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteActivity,
    onSuccess: async () => {
      await queryClient.invalidateQueries(infiniteActivityKeys.all);
    },
  });
}
